import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  private isLoadingSource: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(true);
  public isLoading$: Observable<boolean> = this.isLoadingSource.asObservable();

  public show(): void {
    this.isLoadingSource.next(true);
  }

  public hide(): void {
    this.isLoadingSource.next(false);
  }
}
